module.exports = __webpack_public_path__ + "img/lak.fa9d2eb9.png";